// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m9-0";
export var assigneeDetails = "_m9-1";
export var assigneeInfo = "_m9-2";
export var dropdownContainer = "_m9-4";
export var dropdownImage = "_m9-5";
export var editAssigneeInfo = "_m9-3";
export var editAssigneeModalContainer = "_m9-6";
export var hidden = "_m9-8";
export var input = "_m9-7";